import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { getFolderInfo } from '../../../apis/tms/training.api';
import { FOLDER_INFO } from '../../../constant/QueryKeyName';
import { ROLE_ACCESS, TRoleAccess } from '../../../constant/storage';

import Image from 'next/image';
import { GROUP_PRIVACY } from '../../../constant/group';
import { FolderStatusEnum } from '../../../interfaces/training.interface';
import GroupCover from './GroupCover';
import OtherRoleButtonGroups from './general-group-info-bar-component/OtherRoleButtonGroups';
import OwnerButtonGroups from './general-group-info-bar-component/OwnerButtonGroups';
import RequestRemainingText from './general-group-info-bar-component/RequestRemainingText';

const GeneralGroupInfoBar: React.FunctionComponent<{
  folderStatus: FolderStatusEnum;
  mineRole: TRoleAccess;
}> = ({ folderStatus, mineRole }) => {
  const router = useRouter();

  const [folderId, setFolderId] = useState<string>('');
  const [hiddenDescription, setHiddenDescription] = useState<boolean>(false);
  const [hiddenDescriptionFlag, setHiddenDescriptionFlag] =
    useState<boolean>(false);

  const { data: folder } = useQuery<{ [key: string]: any }>(
    [FOLDER_INFO, folderId],
    () => getFolderInfo(folderId),
    {
      refetchOnMount: true,
      keepPreviousData: true,
      enabled: !!folderId,
      retry: false,
    }
  );

  const desRef = useRef<HTMLDivElement>(null);

  const numberOfLine = () => {
    if (desRef?.current) return desRef?.current?.clientHeight / 20;
    return 0;
  };

  useEffect(() => {
    if (router.isReady) {
      setFolderId(router.query?.gid as string);
    }
  }, [router]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (numberOfLine() > 3 && !hiddenDescriptionFlag) {
      setHiddenDescription(true);
      setHiddenDescriptionFlag(true);
    }
  });

  return (
    <>
      <GroupCover />
      <div
        // ref={desContainerRef}
        className="flex flex-col gap-4 mb-4"
      >
        <div className="flex flex-col justify-end lg:justify-between lg:flex-row gap-5">
          <div className="flex items-center justify-between">
            <div className="w-full h-full flex flex-col justify-center gap-2 ">
              <h1 className="font-bold text-xl">{folder?.folderName}</h1>
              <div className="inline-flex w-fit items-center gap-2 px-[12px] py-[6px] rounded-xl bg-[#F1F1F1] text-[#7C7C7C] text-xs">
                <Image
                  alt="public"
                  className=""
                  src={
                    GROUP_PRIVACY[folder?.status as keyof typeof GROUP_PRIVACY]
                      ?.icon
                  }
                  width={14}
                  height={14}
                />
                <p>
                  {
                    GROUP_PRIVACY[folder?.status as keyof typeof GROUP_PRIVACY]
                      ?.label
                  }
                </p>
              </div>
              <div
                className={`${
                  hiddenDescription ? 'max-h-[60px] overflow-hidden' : ''
                } leading-[20px]`}
              >
                <div
                  id="description-group"
                  style={{ wordBreak: 'break-word' }}
                  ref={desRef}
                  className="text-slate_gray text-sm break-words max-w-[286px] md:max-w-[584px]"
                >
                  {folder?.description}
                </div>
              </div>
              {desRef?.current &&
                numberOfLine() > 3 &&
                hiddenDescription &&
                folder?.description && (
                  <span
                    className="cursor-pointer text-primary_lighter"
                    onClick={() => setHiddenDescription(false)}
                  >
                    Xem thêm
                  </span>
                )}
            </div>
          </div>

          {mineRole === ROLE_ACCESS.Owner ? (
            <OwnerButtonGroups folderId={folderId} />
          ) : (
            <OtherRoleButtonGroups
              mineRole={mineRole}
              folderId={folderId}
              folderStatus={folderStatus}
              folder={folder}
            />
          )}
        </div>
        {mineRole && mineRole === ROLE_ACCESS.Owner && (
          <div className="hidden lg:flex mt-4 w-full">
            <RequestRemainingText />
          </div>
        )}
      </div>
    </>
  );
};

export default GeneralGroupInfoBar;
